import * as React from 'react';
import { NavigateFunction, Params, To, useLocation, useNavigate, useParams, Location } from 'react-router-dom';
import hoistStatics from 'hoist-non-react-statics';
import { useQueryParams, useRouterProps } from 'app/area/shared/navigation';

export type LocationWithQuery = Location & {query: QueryObject};
export interface RouterProps {
  location: LocationWithQuery;
  navigate: NavigateFunction;
  to: NavigateFunction;
  replace: NavigateFunction;
}
export interface WithRouterProps {
  router: RouterProps;
  params: Readonly<Params<string>>;
}
export interface QueryObject {
   [key: string]: string;
}

export function withRouter(WrappedComponent: React.ComponentType<React.PropsWithChildren<any>>) {
  function ComponentWithRouterProp(props: any) {
    // eslint:disable: prefer-const
    const location = useLocation();
    const { query } = useQueryParams();
    const previousLocation = (location.state && (location.state as any)?.previousLocation) || location;

    const locationWithQuery = { location: {...previousLocation, query }};

    const navigate = useNavigate();
    const params = useParams();
    useRouterProps({location, navigate});

    const routerProps = React.useMemo(
      () => ({
        router: { 
        ...locationWithQuery, 
        to: navigate, 
        replace: (route: To) => { navigate(route, { replace: true }) }
        },
        params
      }
      ), [location.hash, location.key, location.pathname, location.search, location.state, query]
    );

    return (<WrappedComponent
        {...props}
        {...routerProps}
      />);
  }

  return hoistStatics(ComponentWithRouterProp, WrappedComponent);
}
